import { Action, ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import {
  PlayerAction,
  PlayerMutation,
  PlayerState
} from "@/components/player/types";

const updatePause = (
  context: ActionContext<PlayerState, RootState>,
  pause: boolean
): void => {
  context.commit(PlayerMutation.SetPause, pause);
};

export const actions: ActionTree<PlayerState, RootState> &
  Record<PlayerAction, Action<PlayerState, RootState>> = {
  [PlayerAction.UpdatePause]: updatePause
};
